var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "376px",
        height: _vm.height,
        viewBox: _vm.dimension,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("5-page/mobile/basic-chat/geberit")]),
      _c(
        "defs",
        [
          _c("rect", {
            attrs: {
              id: "path-1",
              x: "0",
              y: "0",
              width: "375",
              height: "700",
            },
          }),
          _c("rect", {
            attrs: { id: "path-3", x: "0", y: "0", width: "375", height: "50" },
          }),
          _c("rect", {
            attrs: { id: "path-5", x: "0", y: "0", width: "375", height: "50" },
          }),
          _c(
            "filter",
            {
              attrs: {
                x: "-5.3%",
                y: "-20.0%",
                width: "110.7%",
                height: "180.0%",
                filterUnits: "objectBoundingBox",
                id: "filter-7",
              },
            },
            [
              _c("feMorphology", {
                attrs: {
                  radius: "5",
                  operator: "erode",
                  in: "SourceAlpha",
                  result: "shadowSpreadOuter1",
                },
              }),
              _c("feOffset", {
                attrs: {
                  dx: "0",
                  dy: "10",
                  in: "shadowSpreadOuter1",
                  result: "shadowOffsetOuter1",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "10",
                  in: "shadowOffsetOuter1",
                  result: "shadowBlurOuter1",
                },
              }),
              _c("feColorMatrix", {
                attrs: {
                  values:
                    "0 0 0 0 0.196078431   0 0 0 0 0.196078431   0 0 0 0 0.196078431  0 0 0 0.05 0",
                  type: "matrix",
                  in: "shadowBlurOuter1",
                },
              }),
            ],
            1
          ),
          _c(
            "filter",
            { attrs: { id: "filter-8" } },
            [
              _c("feColorMatrix", {
                attrs: {
                  in: "SourceGraphic",
                  type: "matrix",
                  values:
                    "0 0 0 0 0.652287 0 0 0 0 0.652287 0 0 0 0 0.652287 0 0 0 1.000000 0",
                },
              }),
            ],
            1
          ),
          _c("circle", {
            attrs: { id: "path-9", cx: "32", cy: "32", r: "31" },
          }),
          _c(
            "radialGradient",
            {
              attrs: {
                cx: "50%",
                cy: "50%",
                fx: "50%",
                fy: "50%",
                r: "50%",
                id: "radialGradient-11",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#004069", offset: "0%" } }),
              _c("stop", {
                attrs: {
                  "stop-color": "#EEEEEE",
                  "stop-opacity": "0",
                  offset: "100%",
                },
              }),
            ],
            1
          ),
          _c("rect", {
            attrs: {
              id: "path-12",
              x: "0",
              y: "3.49805655e-14",
              width: "7",
              height: "4.92307692",
            },
          }),
          _c("path", {
            attrs: {
              d: "M4.890402,0 L6.556,0 C7.35349918,3.39778733e-16 8,0.646500821 8,1.444 L8,22.1867692 C8,22.9842684 7.35349918,23.6307692 6.556,23.6307692 L2.75508397,23.6307692 C2.14899951,23.6307469 1.6074161,23.252259 1.39908844,22.6831035 C0.466362815,20.1348777 0,16.9301273 0,13.0688524 C0,9.76128163 0.342200592,6.45371087 1.02660178,3.14614012 C1.40572183,1.31399426 3.01944223,3.43689734e-16 4.890402,0 Z",
              id: "path-14",
            },
          }),
          _c("path", {
            attrs: {
              d: "M4.890402,0 L6.556,0 C7.35349918,3.39778733e-16 8,0.646500821 8,1.444 L8,22.1867692 C8,22.9842684 7.35349918,23.6307692 6.556,23.6307692 L2.75508397,23.6307692 C2.14899951,23.6307469 1.6074161,23.252259 1.39908844,22.6831035 C0.466362815,20.1348777 0,16.9301273 0,13.0688524 C0,9.76128163 0.342200592,6.45371087 1.02660178,3.14614012 C1.40572183,1.31399426 3.01944223,3.43689734e-16 4.890402,0 Z",
              id: "path-16",
            },
          }),
          _c("path", {
            attrs: {
              d: "M2.51448232,1.28748669 C6.88632005,0.429162229 11.5238587,0 16.4270984,0 C21.426291,0 26.4277716,0.446123383 31.4315403,1.33837015 C32.8915321,1.59872301 33.9170331,2.92257596 33.8041748,4.40129929 L32.3147538,23.9163927 C32.1998617,25.4217637 30.9448776,26.5846154 29.4351285,26.5846154 L4.56487148,26.5846154 C3.0551224,26.5846154 1.80013832,25.4217637 1.68524617,23.9163927 L0.191234377,4.34114753 C0.0798536903,2.88157571 1.0780885,1.5694944 2.51448232,1.28748669 Z",
              id: "path-18",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-20",
              x: "4.26325641e-14",
              y: "0",
              width: "43",
              height: "21.6615385",
              rx: "10.8307692",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-22",
              x: "4.26325641e-14",
              y: "-5.32907052e-15",
              width: "45",
              height: "23.6307692",
              rx: "11.8153846",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-24",
              x: "0",
              y: "0",
              width: "375",
              height: "48",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-26",
              x: "0",
              y: "0",
              width: "375",
              height: "56",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-28",
              x: "0",
              y: "0",
              width: "315",
              height: "40",
              rx: "20",
            },
          }),
          _c(
            "filter",
            {
              attrs: {
                x: "-3.8%",
                y: "-30.0%",
                width: "107.6%",
                height: "160.0%",
                filterUnits: "objectBoundingBox",
                id: "filter-29",
              },
            },
            [
              _c("feOffset", {
                attrs: {
                  dx: "0",
                  dy: "0",
                  in: "SourceAlpha",
                  result: "shadowOffsetOuter1",
                },
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "4",
                  in: "shadowOffsetOuter1",
                  result: "shadowBlurOuter1",
                },
              }),
              _c("feColorMatrix", {
                attrs: {
                  values:
                    "0 0 0 0 0.588235294   0 0 0 0 0.588235294   0 0 0 0 0.588235294  0 0 0 0.8 0",
                  type: "matrix",
                  in: "shadowBlurOuter1",
                },
              }),
            ],
            1
          ),
          _c("circle", {
            attrs: { id: "path-30", cx: "24", cy: "24", r: "23.25" },
          }),
          _c("rect", {
            attrs: {
              id: "path-32",
              x: "0",
              y: "2.62354241e-14",
              width: "5.25",
              height: "3.69230769",
            },
          }),
          _c("path", {
            attrs: {
              d: "M3.6678015,0 L4.917,0 C5.51512438,-1.09873667e-16 6,0.484875616 6,1.083 L6,16.6400769 C6,17.2382013 5.51512438,17.7230769 4.917,17.7230769 L2.06631298,17.7230769 C1.61174964,17.7230602 1.20556207,17.4391942 1.04931633,17.0123276 C0.349772111,15.1011582 0,12.6975955 0,9.80163929 C0,7.32096814 0.256649013,4.84029699 0.76994704,2.35962583 C1.05427278,0.985503187 2.26457159,2.57769152e-16 3.6678015,0 Z",
              id: "path-34",
            },
          }),
          _c("path", {
            attrs: {
              d: "M3.6678015,0 L4.917,0 C5.51512438,-1.09873667e-16 6,0.484875616 6,1.083 L6,16.6400769 C6,17.2382013 5.51512438,17.7230769 4.917,17.7230769 L2.06631298,17.7230769 C1.61174964,17.7230602 1.20556207,17.4391942 1.04931633,17.0123276 C0.349772111,15.1011582 0,12.6975955 0,9.80163929 C0,7.32096814 0.256649013,4.84029699 0.76994704,2.35962583 C1.05427278,0.985503187 2.26457159,2.57769152e-16 3.6678015,0 Z",
              id: "path-36",
            },
          }),
          _c("path", {
            attrs: {
              d: "M1.88586174,0.965615015 C5.16474004,0.321871672 8.64289405,0 12.3203238,0 C16.0697182,0 19.8208287,0.334592537 23.5736553,1.00377761 C24.6686491,1.19904226 25.4377748,2.19193197 25.3531311,3.30097447 L24.2360654,17.9372945 C24.1498963,19.0663228 23.2086582,19.9384615 22.0763464,19.9384615 L3.42365361,19.9384615 C2.2913418,19.9384615 1.35010374,19.0663228 1.26393463,17.9372945 L0.143425783,3.25586065 C0.0598902677,2.16118178 0.808566375,1.1771208 1.88586174,0.965615015 Z",
              id: "path-38",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-40",
              x: "3.19744231e-14",
              y: "0",
              width: "32.25",
              height: "16.2384615",
              rx: "8.11923077",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-42",
              x: "3.19744231e-14",
              y: "-3.99680289e-15",
              width: "33.75",
              height: "17.7230769",
              rx: "8.86153846",
            },
          }),
          _c("polygon", {
            attrs: {
              id: "path-44",
              points: "-3.08 4.08 17.08 4.08 17.08 16.08 9.32615385 16.08",
            },
          }),
          _c("path", {
            attrs: {
              d: "M6,0 L269.409836,0 C272.723545,-6.08718376e-16 275.409836,2.6862915 275.409836,6 L275.409836,58 C275.409836,61.3137085 272.723545,64 269.409836,64 L6,64 C2.6862915,64 4.05812251e-16,61.3137085 0,58 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
              id: "path-46",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-48",
              x: "0",
              y: "0",
              width: "275",
              height: "38",
              rx: "4",
            },
          }),
          _c("rect", {
            attrs: {
              id: "path-50",
              x: "0",
              y: "0",
              width: "275",
              height: "38",
              rx: "6",
            },
          }),
          _c("path", {
            attrs: {
              d: "M4.42528125,0.57953125 C4.46698438,0.57953125 4.50120313,0.592890625 4.5279375,0.61965625 C4.55467188,0.646375 4.56803125,0.680609375 4.56803125,0.722203125 L4.56803125,0.722203125 L4.56803125,1.00775 C4.56803125,1.04942187 4.55467188,1.08359375 4.5279375,1.11035937 C4.50120313,1.13709375 4.46698438,1.15051562 4.42528125,1.15051562 L4.42528125,1.15051562 L1.28475,1.15051562 C1.08846875,1.15051562 0.920421875,1.220375 0.780625,1.36017187 C0.64084375,1.49995312 0.570984375,1.6679375 0.570984375,1.86421875 L0.570984375,1.86421875 L0.570984375,5.57579687 C0.570984375,5.77210937 0.640859375,5.94010937 0.780625,6.07989062 C0.920421875,6.21965625 1.08846875,6.28948437 1.28475,6.28948437 L1.28475,6.28948437 L4.996375,6.28948437 C5.19267188,6.28948437 5.36073438,6.21965625 5.5005,6.07989062 C5.64026563,5.94009375 5.71010938,5.77209375 5.71010938,5.57579687 L5.71010938,5.57579687 L5.71010938,4.14828125 C5.71010938,4.106625 5.72346875,4.07242187 5.7503125,4.04573437 C5.7769375,4.01889062 5.81115625,4.00553125 5.85285938,4.00553125 L5.85285938,4.00553125 L6.13839063,4.00553125 C6.17998438,4.00553125 6.21420313,4.01889062 6.24096875,4.04573437 C6.2678125,4.07246875 6.2811875,4.1066875 6.2811875,4.14839062 L6.2811875,4.14839062 L6.2811875,5.57585937 C6.2811875,5.92973437 6.15553125,6.23239062 5.90420313,6.48359375 C5.65289063,6.73490625 5.35023438,6.860625 4.996375,6.860625 L4.996375,6.860625 L1.28476563,6.860625 C0.930890625,6.860625 0.628265625,6.73490625 0.376921875,6.48359375 C0.12565625,6.23239062 3.34399175e-13,5.92971875 3.34399175e-13,5.57585937 L3.34399175e-13,5.57585937 L3.34399175e-13,1.86426562 C3.34399175e-13,1.51039062 0.12565625,1.20776562 0.37690625,0.956484375 C0.62825,0.7051875 0.930875,0.57953125 1.28475,0.57953125 L1.28475,0.57953125 Z M7.70857812,0.008546875 C7.78584375,0.008546875 7.85284375,0.03678125 7.90935937,0.093296875 C7.96582812,0.14978125 7.99417187,0.21665625 7.99417187,0.29403125 L7.99417187,0.29403125 L7.99417187,2.57809375 C7.99417187,2.65542187 7.9659375,2.72232812 7.90942187,2.77882812 C7.85289062,2.83534375 7.78595312,2.86360937 7.708625,2.86360937 C7.63129687,2.86360937 7.56435937,2.83534375 7.50789062,2.77882812 L7.50789062,2.77882812 L6.72271875,1.99370312 L3.81415625,4.90226562 C3.7844375,4.93201562 3.75020312,4.94682812 3.71154687,4.94682812 C3.67289062,4.94682812 3.63867187,4.932 3.6089375,4.90226562 L3.6089375,4.90226562 L3.100375,4.39376562 C3.07064062,4.36403125 3.05575,4.32982812 3.05575,4.29109375 C3.05575,4.2525 3.07059375,4.21828125 3.100375,4.18854687 L3.100375,4.18854687 L6.00892187,1.2799375 L5.2238125,0.4948125 C5.16729687,0.438296875 5.139,0.371359375 5.139,0.29403125 C5.139,0.216703125 5.16729687,0.14978125 5.2238125,0.093296875 C5.28028125,0.03678125 5.34723437,0.008546875 5.42454687,0.008546875 L5.42454687,0.008546875 Z",
              id: "path-52",
            },
          }),
        ],
        1
      ),
      _c(
        "g",
        {
          attrs: {
            id: "5---Pages",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "pages/mobile/basic-chat",
                transform: "translate(-167.000000, -1182.000000)",
              },
            },
            [
              _c("rect", {
                attrs: {
                  fill: "#F5F5F5",
                  x: "0",
                  y: "0",
                  width: "940",
                  height: "3618",
                },
              }),
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(167.500000, 1182.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    { attrs: { id: "5-page/mobile/basic-chat/xxx_master" } },
                    [
                      _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                        _c("use", { attrs: { "xlink:href": "#path-1" } }),
                      ]),
                      _c("use", {
                        attrs: {
                          id: "widget-mask-copy",
                          fill: "#D8D8D8",
                          "xlink:href": "#path-1",
                        },
                      }),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group",
                            mask: "url(#mask-2)",
                            fill: "#E2E2E2",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "1-atom/color/chat/widget-background",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  id: "Color",
                                  x: "0",
                                  y: "-4.97379915e-13",
                                  width: "375",
                                  height: "700",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "g",
                        { attrs: { id: "Group", mask: "url(#mask-2)" } },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "4-template/header/xxx_master/headerbar",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: { id: "3-organism/header/headerbar" },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/header/headerbar/background",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        {
                                          attrs: {
                                            id: "mask-4",
                                            fill: "white",
                                          },
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#path-3" },
                                          }),
                                        ]
                                      ),
                                      _c("use", {
                                        attrs: {
                                          id: "Background",
                                          fill: "#868686",
                                          "xlink:href": "#path-3",
                                        },
                                      }),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            mask: "url(#mask-4)",
                                            fill: _vm.header,
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/color/branding/_nobranding_1",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id: "Color",
                                                  x: "0",
                                                  y: "0",
                                                  width: "375",
                                                  height: "50",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform:
                                          "translate(345.000000, 17.000000)",
                                        stroke:
                                          _vm.headerContrast === "light"
                                            ? "#FFFFFF"
                                            : "#484848",
                                        "stroke-linecap": "square",
                                        "stroke-width": "1.92",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "atom/header/closewidget",
                                          },
                                        },
                                        [
                                          _c("line", {
                                            attrs: {
                                              x1: "-1.92",
                                              y1: "7.68",
                                              x2: "17.28",
                                              y2: "7.68",
                                              id: "Line",
                                              transform:
                                                "translate(7.680000, 7.680000) rotate(-315.000000) translate(-7.680000, -7.680000) ",
                                            },
                                          }),
                                          _c("line", {
                                            attrs: {
                                              x1: "-1.92",
                                              y1: "7.68",
                                              x2: "17.28",
                                              y2: "7.68",
                                              id: "Line-Copy",
                                              transform:
                                                "translate(7.680000, 7.680000) rotate(-405.000000) translate(-7.680000, -7.680000) ",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform:
                                          "translate(14.000000, 17.000000)",
                                        opacity: "0",
                                        stroke: "#FFFFFF",
                                        "stroke-linecap": "square",
                                        "stroke-width": "2",
                                      },
                                    },
                                    [
                                      _c("g", { attrs: { id: "menu" } }, [
                                        _c("line", {
                                          attrs: {
                                            x1: "-9.05941988e-14",
                                            y1: "0.6",
                                            x2: "19.2",
                                            y2: "0.6",
                                            id: "Line-3",
                                          },
                                        }),
                                        _c("line", {
                                          attrs: {
                                            x1: "-9.05941988e-14",
                                            y1: "7.8",
                                            x2: "19.2",
                                            y2: "7.8",
                                            id: "Line-3-Copy",
                                          },
                                        }),
                                        _c("line", {
                                          attrs: {
                                            x1: "-9.05941988e-14",
                                            y1: "15",
                                            x2: "19.2",
                                            y2: "15",
                                            id: "Line-3-Copy-2",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform:
                                          "translate(9.375000, 11.500000)",
                                        fill:
                                          _vm.headerContrast === "light"
                                            ? "#FFFFFF"
                                            : "#484848",
                                        "font-family": "Helvetica",
                                        "font-size": "22",
                                        "font-weight": "normal",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "1-atom/header/headerbar/widgetname",
                                          },
                                        },
                                        [
                                          _c(
                                            "text",
                                            { attrs: { id: "Widgetname" } },
                                            [
                                              _c(
                                                "tspan",
                                                { attrs: { x: "0", y: "21" } },
                                                [_vm._v(_vm._s(_vm.headline))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "3-organism/header/operatorbar",
                                    transform: "translate(0.000000, 50.000000)",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/header/operatorbar/background",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        {
                                          attrs: {
                                            id: "mask-6",
                                            fill: "white",
                                          },
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#path-5" },
                                          }),
                                        ]
                                      ),
                                      _c("g", { attrs: { id: "Background" } }, [
                                        _c("use", {
                                          attrs: {
                                            fill: "black",
                                            "fill-opacity": "1",
                                            filter: "url(#filter-7)",
                                            "xlink:href": "#path-5",
                                          },
                                        }),
                                        _c("use", {
                                          attrs: {
                                            fill: "#FFFFFF",
                                            "fill-rule": "evenodd",
                                            "xlink:href": "#path-5",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform: _vm.title
                                          ? "translate(75.500000, 8.000000)"
                                          : "translate(75.500000, 16.000000)",
                                        fill: "#000000",
                                        "font-family": "Helvetica",
                                        "font-size": "16",
                                        "font-weight": "normal",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        { attrs: { id: "Max-Musterbot" } },
                                        [
                                          _c("text", [
                                            _c(
                                              "tspan",
                                              { attrs: { x: "0", y: "15" } },
                                              [_vm._v(_vm._s(_vm.name))]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.title
                                    ? _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            transform:
                                              "translate(75.500000, 29.000000)",
                                            fill: "#000000",
                                            "font-family": "Helvetica",
                                            "font-size": "13",
                                            "font-weight": "normal",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/header/operatorbar/avatarsubline",
                                              },
                                            },
                                            [
                                              _c(
                                                "text",
                                                { attrs: { id: "Chatbot" } },
                                                [
                                                  _c(
                                                    "tspan",
                                                    {
                                                      attrs: {
                                                        x: "0",
                                                        y: "13",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(_vm.title))]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform:
                                          "translate(235.000000, 16.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "text",
                                        {
                                          attrs: {
                                            id: "by",
                                            "font-family": "Helvetica",
                                            "font-size": "12",
                                            "font-weight": "normal",
                                            "line-spacing": "18",
                                            fill: "#A6A6A6",
                                          },
                                        },
                                        [
                                          _c(
                                            "tspan",
                                            {
                                              attrs: {
                                                x: "59.3261719",
                                                y: "9.5",
                                              },
                                            },
                                            [_vm._v("by")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            filter: "url(#filter-8)",
                                            id: "5e7b90c87169f252339df3cd_logo_moinai",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                transform:
                                                  "translate(76.000000, 0.500000)",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M22.6390341,8.33398721 C22.4558763,8.6741322 22.2074371,8.94366738 21.8935352,9.14226652 C21.5796333,9.34115565 21.2186461,9.44050959 20.8105736,9.44050959 C20.4127591,9.44050959 20.057209,9.34115565 19.743307,9.14226652 C19.4293689,8.94366738 19.1782836,8.6741322 18.9899062,8.33398721 C18.801565,7.9940597 18.7073945,7.6146951 18.7073945,7.19611087 C18.7073945,6.78800213 18.7988827,6.41400213 18.9820768,6.07389339 C19.1650171,5.73400213 19.4161386,5.45935608 19.7354414,5.24988273 C20.0545267,5.04069936 20.4127591,4.93598081 20.8105736,4.93598081 C21.2186461,4.93598081 21.5796333,5.03801706 21.8935352,5.24201706 C22.2074371,5.4460533 22.4558763,5.71830704 22.6390341,6.05819829 C22.8219744,6.39834328 22.9136802,6.77774414 22.9136802,7.19611087 C22.9136802,7.6146951 22.8219744,7.9940597 22.6390341,8.33398721 Z M22.7096802,4.18265245 C22.1760469,3.87929851 21.5585373,3.72745842 20.8576588,3.72745842 C20.1565267,3.72745842 19.5314051,3.87929851 18.9820768,4.18265245 C18.4327484,4.48626013 18.0036162,4.8994435 17.6950789,5.42252878 C17.3863241,5.9458678 17.2320554,6.53173348 17.2320554,7.18037953 C17.2320554,7.88151173 17.3890064,8.49093817 17.7029446,9.00884009 C18.0168465,9.52677825 18.4430789,9.92973987 18.9820768,10.2173987 C19.5208571,10.5050576 20.1407953,10.6489957 20.8419275,10.6489957 C21.5533902,10.6489957 22.1760469,10.4945096 22.7096802,10.1860085 C23.2432772,9.87747122 23.6592154,9.46160554 23.9574222,8.93823028 C24.255629,8.41514499 24.4047143,7.82927932 24.4047143,7.18037953 C24.4047143,6.53173348 24.255629,5.9458678 23.9574222,5.42252878 C23.6592154,4.8994435 23.2432772,4.48626013 22.7096802,4.18265245 L22.7096802,4.18265245 Z",
                                                  id: "Fill-1",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("polygon", {
                                                attrs: {
                                                  id: "Fill-2",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                  points:
                                                    "26.1851471 10.4871876 27.6604861 10.4871876 27.6604861 3.98938166 26.1851471 3.98938166",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M27.5270959,0.719654584 C27.349049,0.562703625 27.1503774,0.484228145 26.9306823,0.484228145 C26.7109147,0.484228145 26.5093795,0.562703625 26.326403,0.719654584 C26.143209,0.876605544 26.0517569,1.07034755 26.0517569,1.30037313 C26.0517569,1.54116418 26.143209,1.737371 26.326403,1.88892111 C26.5093795,2.04072495 26.7109147,2.11651812 26.9306823,2.11651812 C27.1503774,2.11651812 27.349049,2.04072495 27.5270959,1.88892111 C27.7048891,1.737371 27.7939126,1.54116418 27.7939126,1.30037313 C27.7939126,1.07034755 27.7048891,0.876605544 27.5270959,0.719654584",
                                                  id: "Fill-3",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M35.8214286,10.4871876 L35.8214286,5.68445203 C35.8109168,5.10913433 35.6097441,4.64074627 35.2171855,4.27975906 C34.8249893,3.91877186 34.3251386,3.73829638 33.7183582,3.73829638 C33.0905544,3.73829638 32.5414072,3.88223454 32.0705544,4.16989339 C31.6189126,4.44595309 31.2926866,4.81107249 31.0915139,5.26474414 L31.0030704,3.98938166 L29.6691684,3.98938166 L29.6691684,10.4871876 L31.144435,10.4871876 L31.144435,7.44233902 C31.144435,6.96115565 31.2307036,6.53742431 31.4032409,6.171 C31.5761407,5.80490192 31.8164606,5.51720682 32.1252878,5.30780597 C32.4337527,5.09858635 32.7712154,4.99390405 33.1376759,4.99390405 C33.5458209,4.99390405 33.8463113,5.10645203 34.0402345,5.33133049 C34.2334328,5.55646269 34.3356503,5.84143923 34.346162,6.18673134 L34.346162,10.4871876 L35.8214286,10.4871876",
                                                  id: "Fill-4",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M48.3010235,7.77679318 C48.2278038,8.11179104 48.0944136,8.40459701 47.9008529,8.65571855 C47.7069296,8.90684009 47.46371,9.10061834 47.171194,9.23647335 C46.8779531,9.37258209 46.5484648,9.44050959 46.1823667,9.44050959 C45.7948827,9.44050959 45.4338593,9.34115565 45.0992964,9.14226652 C44.764371,8.94366738 44.4975906,8.67144989 44.2989552,8.32612154 C44.0999574,7.98082942 44.0006397,7.599 44.0006397,7.18037953 C44.0006397,6.7306226 44.0970576,6.33828145 44.2909808,6.00324733 C44.4845416,5.6685032 44.7433475,5.40683369 45.0677612,5.21849254 C45.3921748,5.03018763 45.7531983,4.93598081 46.1508316,4.93598081 C46.4962687,4.93598081 46.8152452,5.00147974 47.1081237,5.13218763 C47.4010021,5.26311301 47.6521962,5.4460533 47.8617058,5.68147974 C48.0708529,5.91694243 48.2172921,6.19162473 48.3010235,6.50549041 L48.3010235,7.77679318 Z M48.3042857,5.02402559 C48.096226,4.68939019 47.8000853,4.39582303 47.4144136,4.14339659 C46.9906823,3.86628571 46.4748827,3.72745842 45.8684648,3.72745842 C45.261322,3.72745842 44.7016631,3.86875053 44.1891258,4.15126226 C43.676226,4.43377399 43.268081,4.83669936 42.9646908,5.3597484 C42.6613006,5.88308742 42.5094243,6.51089126 42.5094243,7.24315991 C42.5094243,7.9756823 42.6558635,8.59565672 42.9491045,9.10304691 C43.2419829,9.61069083 43.6370789,9.99520256 44.1340299,10.2566183 C44.6309808,10.5180341 45.1830277,10.6489957 45.7898081,10.6489957 C46.1769296,10.6489957 46.5220043,10.594081 46.8257569,10.4841791 C47.1291471,10.3743497 47.3930277,10.2357761 47.6184861,10.0682772 C47.8432196,9.90106823 48.028806,9.7362516 48.1756077,9.57389979 C48.2223667,9.5220661 48.2636887,9.47342217 48.3010235,9.42742431 L48.3010235,10.4920448 L49.7607036,10.4920448 L49.7607036,3.9943113 L48.4108529,3.9943113 L48.3042857,5.02402559 L48.3042857,5.02402559 Z",
                                                  id: "Fill-5",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M51.7840299,1.88892111 C51.9667164,2.04072495 52.1682516,2.11651812 52.3882729,2.11651812 C52.6079318,2.11651812 52.8065672,2.04072495 52.9845416,1.88892111 C53.162516,1.737371 53.251322,1.54116418 53.251322,1.30037313 C53.251322,1.07034755 53.162516,0.876605544 52.9845416,0.719654584 C52.8065672,0.562703625 52.6079318,0.484228145 52.3882729,0.484228145 C52.1682516,0.484228145 51.9667164,0.562703625 51.7840299,0.719654584 C51.6006183,0.876605544 51.5092751,1.07034755 51.5092751,1.30037313 C51.5092751,1.54116418 51.6006183,1.737371 51.7840299,1.88892111",
                                                  id: "Fill-6",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("polygon", {
                                                attrs: {
                                                  id: "Fill-7",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                  points:
                                                    "51.6426652 10.4920448 53.1179318 10.4920448 53.1179318 3.9943113 51.6426652 3.9943113",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M13.3890405,3.72256503 C12.8971279,3.72256503 12.4289574,3.85599147 11.9843475,4.1228081 C11.5774712,4.36682516 11.2520789,4.70102559 11.0073369,5.12439446 C10.9503561,4.84605117 10.8370832,4.60602132 10.6659595,4.40531983 C10.4827655,4.19098934 10.2500213,4.02349041 9.96750959,3.90307676 C9.68499787,3.78291684 9.36573134,3.72256503 9.01010874,3.72256503 C8.42398934,3.72256503 7.90876972,3.86653945 7.46415991,4.15419829 C7.05380384,4.41978252 6.73065885,4.77221535 6.49414499,5.21117058 L6.38902772,3.98938166 L5.05498081,3.98938166 L5.05498081,10.4871876 L6.53028358,10.4871876 L6.53028358,7.42660768 C6.53028358,6.99769296 6.61390618,6.60016844 6.78140512,6.23381663 C6.94868657,5.8676823 7.17896588,5.57215778 7.47198934,5.34702559 C7.76483156,5.12214712 8.09979318,5.0095629 8.47651173,5.0095629 C8.85315778,5.02011087 9.12243923,5.13784222 9.28479104,5.36272068 C9.44688913,5.58785288 9.53319403,5.8676823 9.543742,6.20242644 L9.543742,10.4871876 L11.0191173,10.4871876 L11.0191173,7.41091258 C11.0294115,6.98199787 11.1157164,6.58693817 11.2780682,6.22595096 C11.4401663,5.86496375 11.6704456,5.57215778 11.9686525,5.34702559 C12.2668593,5.12214712 12.6042857,5.0095629 12.9810043,5.0095629 C13.3576503,5.02011087 13.6217846,5.13784222 13.7735885,5.36272068 C13.9251386,5.58785288 14.0063326,5.8676823 14.0168443,6.20242644 L14.0168443,10.4871876 L15.4921834,10.4871876 L15.4921834,5.66875693 C15.4710874,5.10373348 15.2749168,4.63828145 14.9036354,4.27192964 C14.5321002,3.90579531 14.0271386,3.72256503 13.3890405,3.72256503",
                                                  id: "Fill-8",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M40.1479104,6.12565458 C39.9652239,5.92745416 39.8321962,5.68187846 39.7484648,5.38936247 C39.6650959,5.09702772 39.623049,4.79940085 39.623049,4.49633689 L39.623049,1.89573561 C39.623049,1.39436247 39.5632409,1.01590405 39.4428998,0.759816631 C39.3229211,0.50401919 39.1688699,0.323869936 38.9807463,0.21936887 C38.7929851,0.115049041 38.576226,0.0524136461 38.3304691,0.0313539446 C38.0854371,0.0105117271 37.8320682,0 37.5707249,0 L35.8214286,0 L35.8214286,1.30037313 L37.2731343,1.30037313 C37.4822814,1.30037313 37.6468443,1.34216631 37.766823,1.42564392 C37.8868017,1.50941151 37.9701706,1.66853731 38.0172921,1.90356503 C38.0644136,2.13848401 38.0879744,2.48073134 38.0879744,2.92965458 L38.0879744,4.77834115 C38.0879744,5.26945629 38.1452452,5.66886567 38.2601493,5.97685928 C38.3750533,6.28507036 38.5106183,6.52517271 38.6675693,6.69756503 C38.8241578,6.86988486 38.9756716,7.00298507 39.1217484,7.09697441 C38.9861834,7.19107249 38.8397441,7.32417271 38.6831557,7.49649254 C38.5265672,7.66892111 38.3881023,7.89601066 38.2681237,8.17797868 C38.148145,8.46009168 38.0879744,8.81524307 38.0879744,9.24343284 L38.0879744,11.2957569 C38.0879744,11.7448977 38.0644136,12.0869275 38.0172921,12.3218827 C37.9701706,12.5569104 37.8868017,12.7160362 37.766823,12.7996951 C37.6468443,12.8831727 37.4822814,12.9250384 37.2731343,12.9250384 L35.8214286,12.9250384 L35.8214286,14.2097527 L37.5707249,14.2097527 C37.8320682,14.2097527 38.0854371,14.2019232 38.3304691,14.1862281 C38.576226,14.1705693 38.7955224,14.1078977 38.9887207,13.9982495 C39.181919,13.8885288 39.3359701,13.6873923 39.4508742,13.3950576 C39.5657783,13.1025416 39.623049,12.6794989 39.623049,12.1260384 L39.623049,9.65067164 C39.623049,9.35844563 39.6650959,9.06317484 39.7484648,8.76547548 C39.8321962,8.46784861 39.9652239,8.2198806 40.1479104,8.02135394 C40.3309595,7.82304478 40.5738166,7.72369083 40.8764819,7.72369083 L40.8764819,6.43901279 C40.5738166,6.42879104 40.3309595,6.32425373 40.1479104,6.12565458",
                                                  id: "Fill-9",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M6.53028358,15.2494712 L6.53028358,12.9250384 L3.60334755,12.9250384 C3.39430917,12.9250384 3.22974627,12.8831727 3.10984009,12.7996951 C2.98964392,12.7160362 2.90616631,12.5569104 2.85918977,12.3218827 C2.81217697,12.0869275 2.78865245,11.7448977 2.78865245,11.2957569 L2.78865245,9.24343284 C2.78865245,8.81524307 2.72837313,8.46009168 2.60846695,8.17797868 C2.48827079,7.89601066 2.35002345,7.66892111 2.19328998,7.49649254 C2.03666525,7.32417271 1.89026226,7.19107249 1.75466098,7.09697441 C1.90077399,7.00298507 2.05236034,6.86988486 2.20894883,6.69756503 C2.36571855,6.52517271 2.50128358,6.28507036 2.61633262,5.97685928 C2.73116418,5.66886567 2.78865245,5.26945629 2.78865245,4.77834115 L2.78865245,2.92965458 C2.78865245,2.48073134 2.81217697,2.13848401 2.85918977,1.90356503 C2.90616631,1.66853731 2.98964392,1.50941151 3.10984009,1.42564392 C3.22974627,1.34216631 3.39430917,1.30037313 3.60334755,1.30037313 L5.05498081,1.30037313 L5.05498081,-1.03021122e-15 L3.30564819,-1.03021122e-15 C3.04441365,-1.03021122e-15 2.79111727,0.0105117271 2.54583156,0.0313539446 C2.30029211,0.0524136461 2.08360554,0.115049041 1.89562687,0.21936887 C1.70761194,0.323869936 1.55337953,0.50401919 1.43347335,0.759816631 C1.31327719,1.01590405 1.25332409,1.39436247 1.25332409,1.89573561 L1.25332409,4.49633689 C1.25332409,4.79940085 1.21142217,5.09702772 1.12798081,5.38936247 C1.04428571,5.68187846 0.911076759,5.92745416 0.728462687,6.12565458 C0.54563113,6.32425373 0.30273774,6.42879104 -1.03021122e-15,6.43901279 L-1.03021122e-15,7.72369083 C0.30273774,7.72369083 0.54563113,7.82304478 0.728462687,8.02135394 C0.911076759,8.2198806 1.04428571,8.46784861 1.12798081,8.76547548 C1.21142217,9.06317484 1.25332409,9.35844563 1.25332409,9.65067164 L1.25332409,12.1260384 C1.25332409,12.6794989 1.31059488,13.1025416 1.42564392,13.3950576 C1.54047548,13.6873923 1.69441791,13.8885288 1.88779744,13.9982495 C2.08092324,14.1078977 2.30029211,14.1705693 2.54583156,14.1862281 C2.79111727,14.2019232 3.04441365,14.2097527 3.30564819,14.2097527 L5.05498081,14.2097527 L5.05498081,16.9844499 L6.53028358,16.9844499 L9.543742,14.9474222 L9.543742,14.2097527 L8.06843923,14.2097527 L6.53028358,15.2494712",
                                                  id: "Fill-20",
                                                  fill: "#18293E",
                                                  "fill-rule": "nonzero",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "2-molecule/avatar/xxx_master/kwbot-round",
                                        transform:
                                          "translate(4.000000, -7.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        {
                                          attrs: {
                                            id: "mask-10",
                                            fill: "white",
                                          },
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#path-9" },
                                          }),
                                        ]
                                      ),
                                      _c("use", {
                                        attrs: {
                                          id: "avatarmask-round",
                                          fill: "#999999",
                                          "xlink:href": "#path-9",
                                        },
                                      }),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "bot",
                                            mask: "url(#mask-10)",
                                          },
                                        },
                                        [
                                          _c("image", {
                                            attrs: {
                                              href: _vm.avatar,
                                              width: "64px",
                                              height: "64px",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            mask: "url(#mask-10)",
                                            stroke: "#FFFFFF",
                                            "stroke-width": "3",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            { attrs: { id: "round-border" } },
                                            [
                                              _c("circle", {
                                                attrs: {
                                                  cx: "32",
                                                  cy: "32",
                                                  r: "30.5",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "g",
                        { attrs: { id: "Group", mask: "url(#mask-2)" } },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                transform: "translate(0.000000, 596.000000)",
                                id: "4-template/input/inputbar-qr",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "3-organism/input/qrbar/qr-bar",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/input/qrbar/background",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        {
                                          attrs: {
                                            id: "mask-25",
                                            fill: "white",
                                          },
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#path-24" },
                                          }),
                                        ]
                                      ),
                                      _c("use", {
                                        attrs: {
                                          id: "qrbar",
                                          fill: "#FFFFFF",
                                          "xlink:href": "#path-24",
                                        },
                                      }),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            mask: "url(#mask-25)",
                                            fill: "#ECECEC",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/color/chat/inputbar-background",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id: "Color",
                                                  x: "0",
                                                  y: "-3.41060513e-14",
                                                  width: "375",
                                                  height: "48",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "3-organism/input/qrbar/qr-pills/qr-pill-1",
                                        transform:
                                          "translate(199.531250, 5.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "2-molecule/input/quickreplies/qr-pill",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/input/qrbar/qr-pill",
                                                transform:
                                                  "translate(4.000000, 0.000000)",
                                                fill: "#FFFFFF",
                                                stroke: "#E6E6E6",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id: "qrpill",
                                                  x: "0.5",
                                                  y: "0.5",
                                                  width: "102",
                                                  height: "35",
                                                  rx: "17.5",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "Group",
                                                transform:
                                                  "translate(4.000000, 0.000000)",
                                                fill: "#393939",
                                                "font-family": "Helvetica",
                                                "font-size": "15",
                                                "font-weight": "normal",
                                                "line-spacing": "20",
                                              },
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id: "1-atom/input/qrbar/qrpill-text",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "text",
                                                    { attrs: { id: "qrtext" } },
                                                    [
                                                      _c(
                                                        "tspan",
                                                        {
                                                          attrs: {
                                                            x: "16.0544434",
                                                            y: "23",
                                                          },
                                                        },
                                                        [_vm._v("abbrechen")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "2-molecule/input/quickreplies/qr-pill",
                                            transform:
                                              "translate(107.000000, 0.000000)",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/input/qrbar/qr-pill",
                                                transform:
                                                  "translate(4.000000, 0.000000)",
                                                fill: "#FFFFFF",
                                                stroke: "#E6E6E6",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id: "qrpill",
                                                  x: "0.5",
                                                  y: "0.5",
                                                  width: "58",
                                                  height: "35",
                                                  rx: "17.5",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "Group",
                                                transform:
                                                  "translate(4.000000, 0.000000)",
                                                fill: "#393939",
                                                "font-family": "Helvetica",
                                                "font-size": "15",
                                                "font-weight": "normal",
                                                "line-spacing": "20",
                                              },
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id: "1-atom/input/qrbar/qrpill-text",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "text",
                                                    { attrs: { id: "qrtext" } },
                                                    [
                                                      _c(
                                                        "tspan",
                                                        {
                                                          attrs: {
                                                            x: "14.4963379",
                                                            y: "23",
                                                          },
                                                        },
                                                        [_vm._v("Hilfe")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "3-organism/input/inputbar/inputbar",
                                    transform: "translate(0.000000, 48.000000)",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/input/textinput/background",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        {
                                          attrs: {
                                            id: "mask-27",
                                            fill: "white",
                                          },
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#path-26" },
                                          }),
                                        ]
                                      ),
                                      _c("use", {
                                        attrs: {
                                          id: "inputbar",
                                          fill: "#FFFFFF",
                                          "xlink:href": "#path-26",
                                        },
                                      }),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            mask: "url(#mask-27)",
                                            fill: "#ECECEC",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/color/chat/inputbar-background",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id: "Color",
                                                  x: "0",
                                                  y: "-3.97903932e-14",
                                                  width: "375",
                                                  height: "56",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        transform:
                                          "translate(329.000000, 10.000000)",
                                        "fill-rule": "nonzero",
                                      },
                                    },
                                    [
                                      _c("g", [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              fill: "#AAAAAA",
                                              id: "Sendbutton",
                                            },
                                          },
                                          [
                                            _c("circle", {
                                              attrs: {
                                                cx: "19",
                                                cy: "19",
                                                r: "19",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform:
                                                "translate(7.000000, 12.000000)",
                                              fill: "#FFFFFF",
                                              id: "Paperplane",
                                            },
                                          },
                                          [
                                            _c("polygon", {
                                              attrs: {
                                                points:
                                                  "0.15214481 2.2191781 25.918825 0 6.46800986 18 1.52188467 10.7710478 13.0969071 4.9315068 -3.71258579e-13 8.1077497",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "2-molecule/input/textinput/placeholder",
                                        transform:
                                          "translate(8.000000, 8.000000)",
                                      },
                                    },
                                    [
                                      _c("g", { attrs: { id: "textarea" } }, [
                                        _c("use", {
                                          attrs: {
                                            fill: "black",
                                            "fill-opacity": "1",
                                            filter: "url(#filter-29)",
                                            "xlink:href": "#path-28",
                                          },
                                        }),
                                        _c("use", {
                                          attrs: {
                                            fill: "#FFFFFF",
                                            "fill-rule": "evenodd",
                                            "xlink:href": "#path-28",
                                          },
                                        }),
                                      ]),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            fill: "#333333",
                                            "font-family": "Helvetica",
                                            "font-size": "16",
                                            "font-weight": "normal",
                                            "line-spacing": "20",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "1-atom/input/textinput/textinput-text",
                                              },
                                            },
                                            [
                                              _c(
                                                "text",
                                                {
                                                  attrs: {
                                                    id: "I-have-a-question-ab",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "tspan",
                                                    {
                                                      attrs: {
                                                        x: "13.8970588",
                                                        y: "25",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.inputPlaceholder ||
                                                            "Ich habe eine Frage zu..."
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(0.000000, 99.000000)",
                        id: "3-organism/chat/messages/bot/message-multiline-beginchat",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "2-molecule/chat/bubbles/bot/bubble-multiline-withindicator",
                            transform: "translate(62.000000, 25.000000)",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "1-atom/chat/bubble-bot/bubble-multiline-indicator",
                                fill: "#FFFFFF",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "atom/chat/messages/bot/bubble-indicator",
                                    transform: "translate(-8.000000, 0.000000)",
                                  },
                                },
                                [
                                  _c("polygon", {
                                    attrs: { points: "0 0 13 0 13 12 8 12" },
                                  }),
                                ]
                              ),
                              _c("path", {
                                attrs: {
                                  d: "M6,0 L269,0 C272.313708,-6.08718376e-16 275,2.6862915 275,6 L275,58 C275,61.3137085 272.313708,64 269,64 L6,64 C2.6862915,64 4.05812251e-16,61.3137085 0,58 L0,6 C4.82366169e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
                                  id: "atom/chat/messages/bot/bubble",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "text",
                            {
                              attrs: {
                                id: "atom/chat/messages/bot/text",
                                "font-family": "Helvetica",
                                "font-size": "15",
                                "font-weight": "normal",
                                "line-spacing": "22",
                                fill: "#000000",
                              },
                            },
                            [
                              _c("tspan", { attrs: { x: "12", y: "25" } }, [
                                _vm._v(
                                  "Hallo, ich bin hier um zu helfen. Was "
                                ),
                              ]),
                              _c("tspan", { attrs: { x: "12", y: "47" } }, [
                                _vm._v("kann ich für dich tun?"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(0.000000, 267.000000)",
                        id: "3-organism/chat/messages/bot/message-multiline-indicator",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "2-molecule/chat/bubbles/bot/bubble-multiline-withindicator",
                            transform: "translate(62.000000, 5.000000)",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "1-atom/chat/bubble-bot/bubble-multiline-indicator",
                                fill: "#FFFFFF",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "atom/chat/messages/bot/bubble-indicator",
                                    transform: "translate(-8.000000, 0.000000)",
                                  },
                                },
                                [
                                  _c("polygon", {
                                    attrs: { points: "0 0 13 0 13 12 8 12" },
                                  }),
                                ]
                              ),
                              _c("path", {
                                attrs: {
                                  d: "M6,0 L269,0 C272.313708,-6.08718376e-16 275,2.6862915 275,6 L275,58 C275,61.3137085 272.313708,64 269,64 L6,64 C2.6862915,64 4.05812251e-16,61.3137085 0,58 L0,6 C4.82366169e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
                                  id: "atom/chat/messages/bot/bubble",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "text",
                            {
                              attrs: {
                                id: "atom/chat/messages/bot/text",
                                "font-family": "Helvetica",
                                "font-size": "15",
                                "font-weight": "normal",
                                "line-spacing": "22",
                                fill: "#000000",
                              },
                            },
                            [
                              _c("tspan", { attrs: { x: "12", y: "25" } }, [
                                _vm._v("Schau am besten mal hier in unseren "),
                              ]),
                              _c("tspan", { attrs: { x: "12", y: "47" } }, [
                                _vm._v("Produktfinder:"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "2-molecule/avatar/xxx_master/kwbot-round",
                            transform: "translate(5.000000, -2.500000)",
                          },
                        },
                        [
                          _c(
                            "mask",
                            { attrs: { id: "mask-31", fill: "white" } },
                            [_c("use", { attrs: { "xlink:href": "#path-30" } })]
                          ),
                          _c("use", {
                            attrs: {
                              id: "avatarmask-round",
                              fill: "#999999",
                              "xlink:href": "#path-30",
                            },
                          }),
                          _c(
                            "g",
                            { attrs: { id: "bot", mask: "url(#mask-31)" } },
                            [
                              _c("image", {
                                attrs: {
                                  href: _vm.avatar,
                                  width: "48px",
                                  height: "48px",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Group",
                                mask: "url(#mask-31)",
                                stroke: "#FFFFFF",
                                "stroke-width": "2.25",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "1-atom/avatar/avatar-border/round",
                                  },
                                },
                                [
                                  _c("circle", {
                                    attrs: {
                                      id: "round-border",
                                      cx: "24",
                                      cy: "24",
                                      r: "22.875",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(0.000000, 193.000000)",
                        id: "3-organism/chat/messages/user/message-multiline-indicator-first",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "2-molecule/chat/bubbles/user/bubble-multiline-withindicator",
                            transform: "translate(95.000000, 5.000000)",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "1-atom/chat/bubble-user/bubble-multiline-indicator",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "1-atom/chat/bubble-user/bubble-indicator",
                                    transform:
                                      "translate(262.409836, 51.840000)",
                                  },
                                },
                                [
                                  _c(
                                    "mask",
                                    { attrs: { id: "mask-45", fill: "white" } },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#path-44" },
                                      }),
                                    ]
                                  ),
                                  _c("use", {
                                    attrs: {
                                      id: "atom/chat/messages/bot/bubble-indicator",
                                      fill: "#FFFFFF",
                                      transform:
                                        "translate(7.000000, 10.080000) scale(-1, 1) rotate(-90.000000) translate(-7.000000, -10.080000) ",
                                      "xlink:href": "#path-44",
                                    },
                                  }),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        mask: "url(#mask-45)",
                                        fill: _vm.message,
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "1-atom/color/branding/_nobranding_1",
                                          },
                                        },
                                        [
                                          _c("rect", {
                                            attrs: {
                                              id: "Color",
                                              x: "0",
                                              y: "0",
                                              width: "13",
                                              height: "20.16",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("g", { attrs: { id: "bubble" } }, [
                                _c(
                                  "mask",
                                  { attrs: { id: "mask-47", fill: "white" } },
                                  [
                                    _c("use", {
                                      attrs: { "xlink:href": "#path-46" },
                                    }),
                                  ]
                                ),
                                _c("use", {
                                  attrs: {
                                    id: "atom/chat/messages/bot/bubble",
                                    fill: "#FFFFFF",
                                    "xlink:href": "#path-46",
                                  },
                                }),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Group",
                                      mask: "url(#mask-47)",
                                      fill: _vm.message,
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "1-atom/color/branding/_nobranding_1",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          attrs: {
                                            id: "Color",
                                            x: "0",
                                            y: "0",
                                            width: "275.409836",
                                            height: "72",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Group",
                                fill:
                                  _vm.messageContrast === "light"
                                    ? "#FFFFFF"
                                    : "#484848",
                                "font-family": "Helvetica",
                                "font-size": "15",
                                "font-weight": "normal",
                                "line-spacing": "22",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "1-atom/chat/bubble-user/text-multiline",
                                  },
                                },
                                [
                                  _c(
                                    "text",
                                    {
                                      attrs: {
                                        id: "atom/chat/messages/bot/text",
                                      },
                                    },
                                    [
                                      _c(
                                        "tspan",
                                        { attrs: { x: "12", y: "25" } },
                                        [
                                          _vm._v(
                                            "Wo bekomme ich Informationen "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "tspan",
                                        { attrs: { x: "12", y: "47" } },
                                        [_vm._v("über eure neuesten Produkte?")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(0.000000, 341.000000)",
                        id: "3-organism/chat/buttons/button-external",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "2-molecule/chat/button/button-external",
                            transform: "translate(62.000000, 5.000000)",
                          },
                        },
                        [
                          _c(
                            "g",
                            { attrs: { id: "1-atom/chat/button/background" } },
                            [
                              _c(
                                "mask",
                                { attrs: { id: "mask-49", fill: "white" } },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#path-48" },
                                  }),
                                ]
                              ),
                              _c("use", {
                                attrs: {
                                  id: "atom/chat/button/background",
                                  fill: "#FFFFFF",
                                  "xlink:href": "#path-48",
                                },
                              }),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Group",
                                    mask: "url(#mask-49)",
                                    fill: "#FFFFFF",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/color/chat/bot-background",
                                      },
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          id: "Color",
                                          x: "0",
                                          y: "-2.7000624e-14",
                                          width: "275",
                                          height: "38",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "mask",
                                { attrs: { id: "mask-51", fill: "white" } },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#path-50" },
                                  }),
                                ]
                              ),
                              _c("rect", {
                                attrs: {
                                  stroke: "#A6A6A6",
                                  x: "0.5",
                                  y: "0.5",
                                  width: "274",
                                  height: "37",
                                  rx: "6",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "2-molecule/chat/buttontext/buttontext-external",
                                transform: "translate(87.000000, 9.000000)",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Group",
                                    fill: "#484848",
                                    "font-family": "Helvetica",
                                    "font-size": "15",
                                    "font-weight": "normal",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "1-atom/chat/button/buttontext",
                                      },
                                    },
                                    [
                                      _c(
                                        "text",
                                        { attrs: { id: "buttontext" } },
                                        [
                                          _c(
                                            "tspan",
                                            {
                                              attrs: {
                                                x: "0.891845703",
                                                y: "17.0289474",
                                              },
                                            },
                                            [_vm._v("Produktfinder")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "ExternalLink",
                                    transform: "translate(93.000000, 2.500000)",
                                  },
                                },
                                [
                                  _c(
                                    "mask",
                                    { attrs: { id: "mask-53", fill: "white" } },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#path-52" },
                                      }),
                                    ]
                                  ),
                                  _c("use", {
                                    attrs: {
                                      id: "Combined-Shape",
                                      fill: "#8C8C8C",
                                      "fill-rule": "nonzero",
                                      "xlink:href": "#path-52",
                                    },
                                  }),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group",
                                        mask: "url(#mask-53)",
                                        fill: "#333333",
                                      },
                                    },
                                    [
                                      _c("g", { attrs: { id: "Color" } }, [
                                        _c("rect", {
                                          attrs: {
                                            x: "0",
                                            y: "-5.68434189e-14",
                                            width: "300",
                                            height: "80",
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }